// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function useHttps(url) {
  return (url || '').replace(/^http:\/\//i, 'https://');
}
function useWss(url) {
  return (url || '').replace(/^ws:\/\//i, 'wss://');
}

// 请求接口地址 如果没有配置自动获取当前网址路径
var VUE_APP_API_URL = useHttps(process.env.VUE_APP_BASE_API || "".concat(location.origin));
var VUE_APP_WS_URL = useWss(process.env.VUE_APP_WS_URL || "".concat(location.protocol === 'https:' ? 'wss' : 'ws', "://").concat(location.hostname));
var MODULES = ['business', 'region'];
function getAdminModuleByPath() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.pathname;
  var moduleName = path.split('/')[1] ? path.split('/')[1].toLowerCase() : '';
  return MODULES.includes(moduleName) ? moduleName : 'platform';
}
var adminModule = getAdminModuleByPath();
var isPlatform = adminModule === 'platform';
var isBusiness = adminModule === 'business';
var isRegion = adminModule === 'region';
function getAdminModule() {
  return getAdminModuleByPath();
}
function getRoutePrefix() {
  var moduleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getAdminModule();
  return moduleName === 'platform' ? '' : "/".concat(moduleName);
}
function getLoginPath() {
  var moduleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getAdminModule();
  return "".concat(getRoutePrefix(moduleName), "/login");
}
function getHomePath() {
  var moduleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getAdminModule();
  return "".concat(getRoutePrefix(moduleName), "/dashboard");
}
function getModuleLabel() {
  var moduleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getAdminModule();
  var labelMap = {
    platform: '平台',
    business: '商户',
    region: '区域'
  };
  return labelMap[moduleName] || labelMap.platform;
}
var SettingMer = {
  // 服务器地址
  httpUrl: VUE_APP_API_URL,
  // 接口请求地址
  apiBaseURL: VUE_APP_API_URL + '/api/',
  // socket连接
  wsSocketUrl: VUE_APP_WS_URL,
  // 当前后台模块
  adminModule: adminModule,
  // 是否为平台端
  isPlatform: isPlatform
};
export { adminModule, isPlatform, isBusiness, isRegion, getAdminModule, getRoutePrefix, getLoginPath, getHomePath, getModuleLabel };
export default SettingMer;